import { useQuery } from "@tanstack/react-query";

import { listCarePlans } from "~/providers/api/teamMemberPaymentAndCarePlans";
import { useIsTeamMemberStaff } from "~/providers/hooks/auth";

export const useListCarePlans = ({
  withPatients,
  enabled = true,
}: {
  withPatients: boolean;
  enabled?: boolean;
}) => {
  const { isStaff } = useIsTeamMemberStaff();

  const { data, isLoading } = useQuery({
    queryFn: () => listCarePlans(withPatients),
    queryKey: ["listCarePlans", withPatients],
    enabled: enabled && !isStaff,
  });
  return { data, isLoading };
};
